// extracted by mini-css-extract-plugin
export default {"caption":"FileListUpsellMessage_caption__38Qh9","root":"FileListUpsellMessage_root__bigVm","upgradeButton":"FileListUpsellMessage_upgradeButton__Z3Lyk"};